import { useState } from "react";
import LabelledSelect from "components/LabelledSelect";
import { SelectOption } from "components/Select";
import { useCrawler } from "providers/CrawlerProvider";

// Sort options for crawlers
const SORT_OPTIONS: SelectOption<string>[] = [
  { value: "lastRun", name: "Last run" },
  { value: "name", name: "Name" },
  { value: "domain", name: "Domain" },
  { value: "jobs", name: "Jobs" },
  { value: "creditsSpent", name: "Credits spent" },
  { value: "status", name: "Status" },
  { value: "created", name: "Date created" },
];

interface CrawlerSortDropdownProps {
  defaultSort?: string;
}

export const CrawlerSortDropdown = ({
  defaultSort = "lastRun"
}: CrawlerSortDropdownProps) => {
  const { sortCrawlerTableData } = useCrawler();
  const [selectedSort, setSelectedSort] = useState<string>(defaultSort);

  const handleSortChange = (option: SelectOption<string>) => {
    setSelectedSort(option.value);
    sortCrawlerTableData(option.value);
  };

  return (
    <LabelledSelect
      label="Sort by"
      value={SORT_OPTIONS.find((option) => option.value === selectedSort) ?? SORT_OPTIONS[0]}
      options={SORT_OPTIONS}
      onChange={handleSortChange}
      buttonTestId="crawler-sort-dropdown"
      className="w-[216px]"
    />
  );
};

export default CrawlerSortDropdown;
